/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantFilters {
    getFixupPrototypeFunction() { return TenantFilters.fixupPrototype; }

    static newInstance(model: Partial<TenantFilters>): TenantFilters {
        let obj = Object.assign(new TenantFilters(), model);
        TenantFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantFilters>): TenantFilters {
        if (!model) return null;
        return TenantFilters.newInstance(<TenantFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantFilters) {
        if (!obj) return;

        models.TenantFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantFilters): boolean {
        Object.setPrototypeOf(obj, TenantFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Text query to search by name and description
     */
    search: string;

    /**
     * Indicates the status of the Tenant
     */
    status: models.TenantStatus;

}
